import React, { useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Avatar,
  Typography,
  IconButton,
  Button,
  Chip,
  TablePagination,
  styled,
  tableCellClasses,
  Box,
  TextField,
  Backdrop,
  CircularProgress,
  Skeleton,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { encryptId } from "../../Components/CryptoComponent";
import {
  Edit,
  Delete,
  Visibility,
  FilterList,
  Add,
  Search,
  RestartAlt,
} from "@mui/icons-material";
import WorkIcon from "@mui/icons-material/Work";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { useLocation, useNavigate } from "react-router-dom";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import SelectInput from "../../Components/InputComponents/SelectInput";
import { errorNotify } from "../../Components/ToastComponent/ToastNotification";
import CommonButton from "../../Components/InputComponents/CommonButton";
import { useStaffLayout } from "../../Components/Context/CandidateLayoutContext";
import TextInput from "../../Components/InputComponents/TextInput";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: `#2C5F8E`,
    color: `#FFFFFF`,
    fontSize: 14,
    fontWeight: 500,
    whiteSpace: "nowrap",
    fontFamily: "Geist, sans-serif",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "Geist, sans-serif",
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(even)": {
    backgroundColor: `#EBF2FF`,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: "#D6E6F2",
    boxShadow: "0px 0px 5px 0px grey",
  },
}));

const ListStaff = ({ isAdmin }) => {
  const { privilegeData } = useStaffLayout();

  function hasStaffAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isEmployee = subModule.subModuleName
        .toLowerCase()
        .includes("employee");
      if (!isEmployee) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasStaffEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isEmployee = subModule.subModuleName
        .toLowerCase()
        .includes("employee");
      if (!isEmployee) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  function hasStaffViewprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isEmployee = subModule.subModuleName
        .toLowerCase()
        .includes("employee");
      if (!isEmployee) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned === true
      );
    });
  }

  const navigate = useNavigate();
  const location = useLocation();

  const [StaffData, setStaffData] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [pageCount, setPageCount] = useState("");
  const [loaderOpen, setLoaderOpen] = useState(true);

  const [open, setOpen] = useState(false);

  const [branchList, setBranchList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [reportingPersonList, setReportingPersonList] = useState([]);

  const [filterData, setFilterData] = useState({
    UserName: "",
    Name: "",
    ContactNumber: "",
    Department: "",

    Designation: "",
    Branch: "",
    ReportingPerson: "",
    UserRole: "",
    UserStatus: "",
  });

  useEffect(() => {
    if (open != true) {
      setFilterData({
        ...filterData,
        UserName: "",

        ReportingPerson: "",
        UserRole: "",
        UserStatus: "",
      });
    }
  }, [open]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleApplyFilters = () => {
    getData();
    setPage(0);

    // navigate("/Candidates", { replace: true }); // removes the old route state
  };

  const handleResetFilters = () => {
    const resetFilters = {
      UserName: "",
      Name: "",
      ContactNumber: "",
      UserRole: "",
      UserStatus: "",
      Branch: "",
      Department: "",
      Designation: "",
      ReportingPerson: "",
    };

    setFilterData(resetFilters);
    getData(resetFilters);

    navigate("/Staffs", { replace: true }); // removes the old route state
  };

  const paginationState = {
    pagination: { page, rowsPerPage },
    filterData: filterData,
    open: open,
  };

  const navigatetoAdd = () => {
    navigate(`/Staffs/Add`, { state: paginationState });
  };

  const navigatetoEdit = (id) => {
    const encrypted = encodeURIComponent(encryptId(id?.ED_UserId));
    navigate(`/Staffs/Edit/${encrypted}`, { state: paginationState });
  };

  const navigatetoView = (id) => {
    const encrypted = encodeURIComponent(encryptId(id?.ED_UserId));
    navigate(`/Staffs/View/${encrypted}`, {
      state: paginationState,
    });
  };

  const getData = (filters = filterData) => {
    const trimmedFilters = {
      UserName: filters?.UserName?.trim() || "",
      Name: filters?.Name?.trim() || "",
      ContactNumber: filters?.ContactNumber,
      Department: filters?.Department,
      Designation: filters?.Designation,
      Branch: filters?.Branch,
      ReportingPerson: filters?.ReportingPerson,

      UserRole: "",
      UserStatus: "",
      // branch_id: filters?.branch?.trim?.() || filters?.branch || "",
    };
    axiosAPI
      ?.post(`/Employee/${rowsPerPage}/${page + 1}/list`, trimmedFilters)
      .then((res) => {
        setPageCount(res?.data?.data?.total_count);
        setStaffData(res?.data?.data?.data);
        setLoaderOpen(false);
      })
      .catch((err) => {
        errorNotify(`Something went wrong`);
      });
  };

  const getDepartment = async () => {
    try {
      const res = await axiosAPI.get(`/Department/active/list`);
      setDepartmentList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getDesignation = async () => {
    try {
      const res = await axiosAPI.get(`/Designation/active/list`);
      setDesignationList(res?.data?.data || []);
    } catch (err) {
      console.error("Active API failed, retrying without 'active'", err);
      try {
        const resFallback = await axiosAPI.get(`/Designation/list`);
        setDesignationList(resFallback?.data?.data || []);
      } catch (fallbackErr) {
        console.error("Fallback API also failed", fallbackErr);
      }
    }
  };

  const getBranches = async () => {
    try {
      const res = await axiosAPI.get(`/Branch/active/list`);
      setBranchList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getReportingPersonList = async () => {
    try {
      const res = await axiosAPI.get(`/Employee/list`);
      setReportingPersonList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getDepartment();
    getDesignation();
    getBranches();
    getReportingPersonList();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (location?.state?.pagination) {
      setPage(location.state.pagination.page || 0);
      setRowsPerPage(location.state.pagination.rowsPerPage || 25);
    }
    if (location?.state?.open) {
      setOpen(location?.state?.open);
    }

    if (location?.state?.filterData) {
      setFilterData(location.state.filterData);
      getData(location.state.filterData); // fetch with restored filters
    } else {
      getData();
    }
  }, [location?.state, page, rowsPerPage]);

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          mb: 2,
          gap: 2,
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
        >
          Staff Management
        </Typography>

        {/* Add Button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            ml: "auto",
          }}
        >
          {hasStaffAddprivilege(privilegeData) && (
            <Button
              variant="contained"
              startIcon={<Add />}
              sx={{ background: "#E75E1F" }}
              onClick={navigatetoAdd}
              disabled={!hasStaffAddprivilege(privilegeData)}
            >
              Add
            </Button>
          )}
        </Box>
      </Box>

      {/* Filters */}
      <Box sx={{ maxWidth: "100%", mb: 2 }}>
        <Grid container spacing={2}>
          {/* Name */}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Name
            </Typography>
            <TextField
              placeholder="Name"
              variant="outlined"
              size="small"
              value={filterData?.Name}
              onChange={(e) => {
                setFilterData((prev) => ({ ...prev, Name: e.target.value }));
              }}
              sx={{ width: { xs: "100%" } }}
            />
          </Grid>

          {/* Contact Number */}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Contact Number
            </Typography>
            <TextField
              placeholder="Contact Number"
              variant="outlined"
              size="small"
              value={filterData?.ContactNumber}
              onChange={(e) => {
                setFilterData((prev) => ({
                  ...prev,
                  ContactNumber: e.target.value,
                }));
              }}
              sx={{ width: { xs: "100%" } }}
            />
          </Grid>

          {/* Department */}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Department
            </Typography>
            <SelectInput
              value={filterData.Department}
              onChange={(e) => {
                setFilterData((prev) => ({
                  ...prev,
                  Department: e.target.value,
                }));
              }}
              options={departmentList?.map((item) => ({
                value: item?.DL_Id,
                label: item?.DL_Name,
              }))}
              placeholder="Select Department"
            />
          </Grid>

          {/* Designation */}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Designation
            </Typography>
            <SelectInput
              placeholder="Select Designation"
              value={filterData?.Designation}
              onChange={(e) => {
                setFilterData((prev) => ({
                  ...prev,
                  Designation: e.target.value,
                }));
              }}
              options={designationList?.map((item) => ({
                value: item?.DI_Id,
                label: item?.DI_Name,
              }))}
            />
          </Grid>

          {/* Branch */}
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Branch
            </Typography>
            <SelectInput
              value={filterData.Branch}
              onChange={(e) => {
                setFilterData((prev) => ({
                  ...prev,
                  Branch: e.target.value,
                }));
              }}
              options={branchList?.map((item) => ({
                value: item?.BL_Id,
                label: item?.BL_Name,
              }))}
              placeholder="Select Branch"
            />
          </Grid>

          {open && (
            <>
              {/* Reporting Person */}
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Reporting Person
                </Typography>
                <SelectInput
                  value={filterData?.ReportingPerson}
                  onChange={(e) => {
                    setFilterData((prev) => ({
                      ...prev,
                      ReportingPerson: e.target.value,
                    }));
                  }}
                  options={reportingPersonList?.map((item) => ({
                    value: item?.ED_Id,
                    label: item?.ED_Name,
                  }))}
                  placeholder="Select Reporting Person"
                />
              </Grid>

              {/* Username */}
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                >
                  Username
                </Typography>
                <TextField
                  placeholder="Username"
                  variant="outlined"
                  size="small"
                  value={filterData?.UserName}
                  onChange={(e) => {
                    setFilterData((prev) => ({
                      ...prev,
                      UserName: e.target.value,
                    }));
                  }}
                  sx={{ width: { xs: "100%" } }}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Box>

      {/* Search/Reset/Filter BTN */}
      <Box
        sx={{
          width: "100%", // Full width
          display: "flex",
          justifyContent: "flex-end", // Align buttons to the right
          alignItems: "flex-end",
          gap: 1,
          my: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            gap: 1,
          }}
        >
          <Button
            variant="outlined"
            startIcon={<Search />}
            onClick={handleApplyFilters}
            sx={{
              textTransform: "capitalize",
              color: "white",
              background: "#006CB8",
            }}
          >
            Search
          </Button>

          <Button
            variant="outlined"
            startIcon={<RestartAlt />}
            onClick={handleResetFilters}
            sx={{ textTransform: "capitalize" }}
          >
            Reset
          </Button>

          <Button
            variant="outlined"
            startIcon={<FilterList />}
            onClick={() => setOpen(!open)}
            sx={{ textTransform: "capitalize" }}
          >
            {open ? "Less" : "More"} Filters
          </Button>
        </Box>
      </Box>

      {/* Table */}
      <TableContainer
        sx={{
          border: "1px solid transparent",
          borderRadius: "10px",
          maxWidth: "100vw",
          overflowX: "auto",
          margin: "auto",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell sx={{ width: "50px" }}>#</StyledTableCell>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell>Contact Number</StyledTableCell>
              <StyledTableCell>Email</StyledTableCell>
              <StyledTableCell>Department</StyledTableCell>
              <StyledTableCell>Employment Status</StyledTableCell>
              <StyledTableCell>Branch </StyledTableCell>
              <StyledTableCell align="center">Status</StyledTableCell>
              {(hasStaffEditprivilege(privilegeData) ||
                hasStaffViewprivilege(privilegeData)) && (
                <StyledTableCell align="center" sx={{ width: "150px" }}>
                  {" "}
                  Actions{" "}
                </StyledTableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {loaderOpen ? (
              Array.from({ length: 7 }).map((_, idx) => (
                <TableRow key={idx}>
                  {Array.from({ length: 9 }).map((_, index) => (
                    <StyledTableCell key={index}>
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={40}
                      />
                    </StyledTableCell>
                  ))}
                </TableRow>
              ))
            ) : StaffData && StaffData?.length > 0 ? (
              StaffData.map((c, index) => (
                <StyledTableRow key={c.id}>
                  <StyledTableCell>
                    {index + 1 + page * rowsPerPage}
                  </StyledTableCell>

                  <StyledTableCell>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Avatar
                        src={`${process.env.REACT_APP_BASE_URL}/${c?.ED_Photo}`}
                        sx={{
                          width: 55,
                          height: 55,
                          mr: 2,
                          border: "1px solid lightgrey",
                          transition:
                            "transform 0.5s ease, box-shadow 0.3s ease",
                          "&:hover": {
                            transform: hasStaffViewprivilege(privilegeData)
                              ? "scale(1.3)"
                              : `scale(1)`,
                            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                            cursor: hasStaffViewprivilege(privilegeData)
                              ? "pointer"
                              : "",
                          },
                        }}
                        onClick={() => {
                          if (hasStaffViewprivilege(privilegeData)) {
                           navigatetoView(c)
                          }
                        }}
                      />

                      <Typography variant="body2">
                         {c?.ED_Name ? c?.ED_Name : "-"}
                      </Typography>
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "14px" },
                        fontFamily: "Geist, sans-serif",
                      }}
                    >
                      {c?.ED_ContactNumber ? c?.ED_ContactNumber : "-"}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "14px" },
                        fontFamily: "Geist, sans-serif",
                      }}
                    >
                      {c?.ED_Email ? c?.ED_Email : "-"}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "14px" },
                        fontFamily: "Geist, sans-serif",
                      }}
                    >
                      {c?.ED_Department_Name ? c?.ED_Department_Name : "-"}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "14px" },
                        fontFamily: "Geist, sans-serif",
                      }}
                    >
                      {c?.ED_EmploymentStatus_Name
                        ? c?.ED_EmploymentStatus_Name
                        : "-"}
                    </Typography>
                  </StyledTableCell>

                  <StyledTableCell>
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "14px" },
                        fontFamily: "Geist, sans-serif",
                      }}
                    >
                      {c?.ED_BranchName ? c?.ED_BranchName : "-"}
                    </Typography>
                  </StyledTableCell>

                  <StyledTableCell align="center">
                    <Chip
                      label={c?.UL_Status_Name}
                      color={
                        c?.UL_Status_Name == "Active" ? "success" : "error"
                      }
                      sx={{
                        fontSize: { xs: "10px", sm: "12px" },
                        width: "80px",
                        fontFamily: "Geist, sans-serif",
                        fontWeight: "600",
                      }}
                    />
                  </StyledTableCell>
                  {(hasStaffViewprivilege(privilegeData) ||
                    hasStaffEditprivilege(privilegeData)) && (
                    <StyledTableCell align="center">
                      {hasStaffViewprivilege(privilegeData) && (
                        <IconButton
                          color="primary"
                          onClick={() => {
                            navigatetoView(c);
                          }}
                          disabled={!hasStaffViewprivilege(privilegeData)}
                        >
                          <Visibility />
                        </IconButton>
                      )}
                      {hasStaffEditprivilege(privilegeData) && (
                        <IconButton
                          color="warning"
                          onClick={() => {
                            navigatetoEdit(c);
                          }}
                          disabled={!hasStaffEditprivilege(privilegeData)}
                        >
                          <Edit />
                        </IconButton>
                      )}
                    </StyledTableCell>
                  )}
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell colSpan={9} align="center">
                  <Typography
                    variant="body2"
                    sx={{
                      py: 2,
                      fontSize: "20px",
                      fontFamily: "Geist, sans-serif",
                    }}
                  >
                    No data available
                  </Typography>
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={pageCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[25, 50, 75, 100]}
        sx={{
          // General font size for the pagination root
          fontSize: { xs: "12px", sm: "14px" },
          // Specific font size for the "Rows per page" label
          "& .MuiTablePagination-selectLabel": {
            fontSize: { xs: "12px", sm: "14px" },
            fontFamily: "Geist, sans-serif", // Optional
          },
        }}
      />
    </Paper>
  );
};

export default ListStaff;
